









































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';
import * as _ from 'lodash';
import moment from 'moment';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
// 接口
import { queryParkingSpacePackageRecord } from '../../../api/parking-space-list';

import * as routeNames from '../router-names';
import Utils from '@root/utils/common';
import {
  packageOperateTypeMap,
  packageTypeMap,
  packageUseTypeMap
} from '../../../types/parking-space-management/dictionaries';

@Component({
  name: 'PackageOperationRecordList',
  components: {
    ParkingLotSearch
  }
})
export default class PackageOperationRecordList extends Mixins(TableMixin, TableWidthMixin) {
  // 车位用途
  useTypeList = Utils.toLabelVal(packageUseTypeMap);

  // 操作类型
  operateTypeList = Utils.toLabelVal(packageOperateTypeMap);

  // table数据
  private tableData: any[] = [];

  // 操作时间
  private operateTime: any = [];

  // 加载中
  loading: boolean = false;

  private filterParam: any = {
    parkId: [], // 车场ID集合,多车场逗号分隔
    name: '', // 套餐名称
    operateTimeStart: '', // 操作时间-开始
    operateTimeEnd: '', // 操作时间-结束
    useType: [], // 车位用途
    operateType: [] // 操作类型
  };
  async created() {
    this.fetchTableData();
  }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  // 点击清除按钮
  private onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      parkId: defaultParkIdList,
      name: '',
      operateTimeStart: '',
      operateTimeEnd: '',
      useType: [],
      operateType: []
    };
    this.operateTime = [];
    this.search();
  }

  /**
   * 获取列表数据
   */
  async fetchTableData() {
    if (this.loading) return;
    this.loading = true;
    try {
      const options = {
        ...this.filterParam,
        parkId: this.filterParam.parkId.join(','),
        operateTimeStart:
          this.filterParam.operateTimeStart && moment(this.filterParam.operateTimeStart).format('YYYY-MM-DD HH:mm:ss'),
        operateTimeEnd:
          this.filterParam.operateTimeStart && moment(this.filterParam.operateTimeEnd).format('YYYY-MM-DD HH:mm:ss'),
        operateType: this.filterParam.operateType.join(','),
        useType: this.filterParam.useType.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      };
      const { status, code, msg, data } = await queryParkingSpacePackageRecord({ ...options });
      const { datas = [], totalNum = 0, total = {} } = data || {};
      this.tableData = datas;
      this.total = Number(totalNum);
    } catch (error) {
      this.$message.error(error.msg);
    } finally {
      this.loading = false;
    }
  }

  // 入场时间改变
  onEnterTimeChange(date: any, dateString: any) {
    let [startTime, endTime] = dateString;
    this.filterParam.operateTimeStart = startTime + ' 00:00:00';
    this.filterParam.operateTimeEnd = endTime + ' 23:59:59';
  }
  get tableColums() {
    return [
      {
        title: '序号',
        width: 70,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '套餐名称',
        dataIndex: 'name',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '套餐类型',
        dataIndex: 'type',
        // customRender: (text: any) => packageUseTypeMap[text],
        width: 180
      },
      {
        title: '授权周期(月)',
        dataIndex: 'period',
        width: 180
      },
      {
        title: '套餐价格(元)',
        dataIndex: 'price',
        width: 180
      },
      {
        title: '车位用途',
        dataIndex: 'useType',
        // customRender: (text: any) => packageUseTypeMap[text],
        width: 180
      },
      {
        title: '操作类型',
        dataIndex: 'operateType',
        // customRender: (text: any) => packageOperateTypeMap[text],
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作备注',
        dataIndex: 'message',
        // customRender: (text: any) => packageOperateTypeMap[text],
        scopedSlots: { customRender: 'text-ellipse' },
        width: 180
      },
      {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: 240
      },
      {
        title: '下发状态',
        dataIndex: 'sendResult'
      },
      {
        title: '操作人',
        dataIndex: 'operater',
        width: 180
      }
    ];
  }
}
